<template>
  <div class="page" :style="{ height:   '100%' }">
    <div class="name-list" id="pageName">
      <van-empty v-if="noData" description="暂无名单" />
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="tip">已提交人数：{{ item.num }}人</div>
        <div class="btns">
          <div class="btn del" @click="delOne(item)">删除名单</div>
          <div class="btn show" @click="gotoDetail(item)">查看名单</div>
        </div>
      </div>
    </div>
    <div class="btn-add">
      <div class="add" @click="openAdd()">新建名单</div>
    </div>

    <van-dialog
      v-model="addFlag"
      title="创建名单"
      :closeOnClickOverlay="true"
      :show-confirm-button="false"
    >
      <div class="addbox">
        <van-field
          v-model="form.title"
          label="活动名称"
          type="textarea"
          placeholder="请输入活动名称"
        />
        <div class="add-btn">
          <div class="btn" @click="addToList()">确认创建</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog, Field, Button, Toast, Cell, Empty } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Mine",
  components: {
    Dialog,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Empty.name]: Empty,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      pageHeight: window.innerHeight,
      isLoading: false,
      params: {
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      },
      dataList: [],
      noData: false,
      addFlag: false,
      form: {},
      price: "",
      vxChecked: true,
      baseInfo: {},
      unionId: "",
      openId: "",
    };
  },
  watch: {},
  async mounted() {
    if(this.$page.isInWechat){
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            console.log("openId", openid);
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
    
    await this.getList();
    this.$nextTick(() => {
      let page = document.getElementById("pageName"); //绑定在当前组件上
      page.addEventListener("scroll", this.scroll, true);
    });
  },
  beforeDestroy: function () {},
  methods: {
    async getList() {
      this.isLoading = true;
      this.params.accountId = this.publicData.id;
      let res = await this.$http.post("/api/collectForm/getList", this.params);
      if (!res.code) {
        console.log("res", res);
        this.noData = false;
        if (this.params.pageNumber == 1) {
          this.dataList = [];
          if (!res.list.length) {
            this.noData = true;
          }
        }
        this.dataList = [...this.dataList, ...res.list];
      }
      this.isLoading = false;
    },
    async openAdd() {
      this.form = {};
      this.addFlag = true;
    },
    async addToList() {
      if (!this.form.title) return;
      let res = await this.$http.post("/api/collectForm/add", {
        accountId: this.publicData.id,
        title: this.form.title,
      });
      if (!res.code) {
        this.$toast("创建成功！");
        this.getList();
        this.addFlag = false;
      }
    },
    async delOne(item) {
      Dialog.confirm({
        title: "提示",
        message: `确定要退保名称号为“${item.title}”的名单吗？`,
      })
        .then(async () => {
          let res = await this.$http.post("/api/collectForm/delete", {
            id: item.id,
          });
          if (!res.code) {
            this.$toast("删除成功！");
            this.params.pageNumber = 1;
            this.getList();
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    gotoDetail(item) {
      this.$router.push({
        name: "NameDetail",
        query: {
          id: item.id,
          name: item.title,
        },
      });
    },
    scroll() {
      if (this.isLoading) return;
      let page = document.getElementById("pageName");
      if (page.scrollTop + window.innerHeight > page.scrollHeight - 1) {
        this.params.pageNumber++;
        this.getList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .name-list {
    padding: 0.15rem;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: scroll;
    flex: 1;
    .item {
      width: 3.46rem;
      height: 1.55rem;
      background: #ffffff;
      box-shadow: 0px -4px 5px 0px rgba(0, 26, 17, 0.06),
        0px 4px 5px 0px rgba(0, 26, 17, 0.06);
      padding: 0.25rem;
      box-sizing: border-box;
      border-radius: 0.05rem;
      margin-bottom: 0.1rem;
      .title {
        font-size: 0.18rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
      }
      .tip {
        font-size: 0.12rem;
        font-family: PingFang;
        font-weight: 500;
        color: #666666;
        margin-top: 0.14rem;
        text-align: center;
      }
      .btns {
        display: flex;
        margin-top: 0.2rem;
        justify-content: center;
        .btn {
          border: 1px solid #2dd97a;
          padding: 0.07rem 0.14rem;
          font-size: 0.12rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: #2dd97a;
          width: fit-content;
          margin: 0 0.1rem;
          border-radius: 0.02rem;
          &.show {
            background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
            color: #fff;
          }
        }
      }
    }
  }
  .btn-add {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 0.1rem;
    flex-shrink: 0;
    .add {
      width: 3.45rem;
      height: 0.45rem;
      background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
      border-radius: 0.45rem;
      font-size: 0.13rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .addbox {
    padding-top: 0.1rem;
    .add-btn {
      width: 100%;
      //   height: 0.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      //   margin-bottom: 15px;
      //   margin-top: 15px;
      padding: 10px 16px;
      box-sizing: border-box;
      .btn {
        height: 0.4rem;
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.4rem;
        background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
        border-radius: 0.45rem;
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px;
      }
    }
  }
}
</style>